module.exports = __webpack_public_path__ + "img/1970East-003_WEB-min.3bc10b65.jpg";